import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as Actions from '@app/core/store/spaycial-integration/spaycial-integration-actions';
import {
  scanUser,
  selectError,
  selectRedirectUrl,
  selectStatus,
} from '@app/core/store/spaycial-integration/spaycial-integration-selectors';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class SpaycialIntegrationService {
  constructor(private store: Store) {}

  public getConnectionStatus(): Observable<boolean | null> {
    return this.store.select(selectStatus);
  }

  public getScanUser(): Observable<boolean | null> {
    return this.store.select(scanUser);
  }

  public getRedirectUrl(): Observable<string | null> {
    return this.store.select(selectRedirectUrl);
  }

  public getError(): Observable<HttpErrorResponse | null> {
    return this.store.select(selectError);
  }

  public loadConnectionStatus(): void {
    this.store.dispatch(Actions.loadStatus());
  }

  public connect(callbackUrl?: string): void {
    this.store.dispatch(Actions.connect({ callbackUrl }));
  }

  public loadConnections(callbackUrl: string): void {
    this.store.dispatch(Actions.loadConnections({ callbackUrl }));
  }

  public loadActivities(callbackUrl: string): void {
    this.store.dispatch(Actions.loadActivities({ callbackUrl }));
  }

  public resetError(): void {
    this.store.dispatch(Actions.resetError());
  }

  public resetRedirectUrl(): void {
    this.store.dispatch(Actions.resetRedirectUrl());
  }

  public disconnect(): void {
    this.store.dispatch(Actions.disconnect());
  }

  public loadProfile(callbackUrl?: string): void {
    this.store.dispatch(Actions.loadProfile({ callbackUrl }));
  }

  public loadOffers(callbackUrl?: string): void {
    this.store.dispatch(Actions.loadOffers({ callbackUrl }));
  }
}
